import React, { Component } from "react";
//import ReactDOM from "react-dom";
import "./artist-card.css";
import "./loading.css";

function Loading() {
  return (
    <React.Fragment>
      <div className="upp">
        <div className="col-md-12 centrar">
          <h3> LOADING...</h3>
        </div>
      </div>
    </React.Fragment>
  );
}

export default Loading;
